import React from 'react';
import { CheckCircle, AlertCircle, X } from 'lucide-react';
import './MessageModal.css';

interface MessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'success' | 'error';
  title: string;
  message: string;
}

export const MessageModal: React.FC<MessageModalProps> = ({
  isOpen,
  onClose,
  type,
  title,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div className="message-modal-overlay" onClick={onClose}>
      <div className="message-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="message-modal-close" onClick={onClose} aria-label="Close">
          <X size={20} />
        </button>

        <div className={`message-modal-icon message-modal-icon--${type}`}>
          {type === 'success' ? (
            <CheckCircle size={48} />
          ) : (
            <AlertCircle size={48} />
          )}
        </div>

        <h2 className="message-modal-title">{title}</h2>
        <p className="message-modal-message">{message}</p>

        <button className="message-modal-button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
